// extracted by mini-css-extract-plugin
module.exports = {"actions":"SearchFurther_actions__2K_tP","searchFurther":"SearchFurther_searchFurther__1q3Vs"};